import React from "react";
import Slider, { SliderSlide } from "components/Slider";
import { BackgroundColor } from "types/componentBackground";
import LinkCard from "components/Card/LinkCard";
import { CollectionSliderDestinationFragment } from "types/graphql-types";
import { FilterByType, filterByDestinationType } from "./utils";

interface DestinationsSliderProps {
  cardBackgroundColor?: BackgroundColor;
  filterByType: FilterByType;
  data: CollectionSliderDestinationFragment[];
}

const DestinationsSlider: React.FC<
  React.PropsWithChildren<DestinationsSliderProps>
> = ({ cardBackgroundColor, filterByType, data }) => {
  const destinations = filterByDestinationType(data, filterByType);

  return (
    <Slider
      variantColor={cardBackgroundColor}
      data-content-name="destinations_slider"
    >
      {destinations.map((item) => {
        return (
          <SliderSlide key={item.id}>
            <LinkCard
              backgroundColor={cardBackgroundColor}
              key={item._id}
              title={item.card?.title?.localized}
              image={item.card?.image}
              description={item.card?.description?.localized}
              action={{ href: item.fullPath }}
            />
          </SliderSlide>
        );
      })}
    </Slider>
  );
};

export default DestinationsSlider;
